import useReveal from "../hooks/useReveal";

const images = [
    {
        src: "/gallery/cirujano-01.jpg",
        caption: "En quirófano",
        alt: "Dr. Erik Cárdenas en quirófano",
    },
    {
        src: "/gallery/cirujano-02.jpg",
        caption: "Equipo quirúrgico",
        alt: "Dr. Erik Cárdenas con equipo médico",
    },
    {
        src: "/gallery/cirujano-03.jpg",
        caption: "Cirugía laparoscópica",
        alt: "Procedimiento laparoscópico",
    },
    {
        src: "/gallery/cirujano-04.jpg",
        caption: "Precisión técnica",
        alt: "Procedimiento quirúrgico",
    },
];

const Galeria = () => {
    const ref = useReveal();
    return (
        <section
            id="galeria"
            data-testid="galeria-section"
            className="relative py-24 lg:py-32 bg-cream"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <div ref={ref} className="reveal max-w-3xl mb-14 lg:mb-16">
                    <div className="flex items-center gap-4 mb-6">
                        <span className="block w-16 h-px bg-gold" />
                        <span className="eyebrow">En el quirófano</span>
                    </div>
                    <h2
                        data-testid="galeria-heading"
                        className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-navy"
                    >
                        Donde la técnica{" "}
                        <span className="italic text-navy/85">se vuelve precisión.</span>
                    </h2>
                    <p className="mt-6 text-ink/70 text-[15px] leading-relaxed font-light max-w-2xl">
                        Cada procedimiento se planea con rigor militar y se ejecuta con la
                        precisión de la cirugía mínimamente invasiva contemporánea.
                    </p>
                </div>

                <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-5">
                    {images.map((img, i) => (
                        <figure
                            key={img.src}
                            data-testid={`gallery-item-${i}`}
                            className="relative group overflow-hidden bg-navy"
                            style={{
                                aspectRatio: i % 3 === 0 ? "3 / 4" : "4 / 5",
                            }}
                        >
                            <img
                                src={img.src}
                                alt={img.alt}
                                loading="lazy"
                                className="absolute inset-0 w-full h-full object-cover grayscale-[0.05] transition-all duration-700 group-hover:scale-105 group-hover:grayscale-0"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-navy/90 via-navy/10 to-transparent pointer-events-none opacity-90 group-hover:opacity-70 transition-opacity duration-500" />
                            <figcaption className="absolute bottom-4 left-4 right-4 flex items-center gap-3 text-cream">
                                <span className="block w-6 h-px bg-gold" />
                                <span className="font-display text-base lg:text-lg leading-tight">
                                    {img.caption}
                                </span>
                            </figcaption>
                            <span className="absolute top-4 right-4 text-[10px] tracking-[0.3em] uppercase text-gold/80">
                                0{i + 1}
                            </span>
                        </figure>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Galeria;
